import PropTypes from 'prop-types';
import React from 'react';
import Navigation from 'utils/navigation'
import { connect } from 'react-redux'

import { Paths } from 'utils/paths'
import log, { error } from 'utils/logger' // eslint-disable-line

class Breadcrumbs extends React.PureComponent {
  static propTypes = {
    current_user: PropTypes.object,
    username: PropTypes.string,
    breadcrumbs: PropTypes.shape({
      set: PropTypes.bool.isRequired,
      options: PropTypes.shape({
        params: PropTypes.shape({
          username: PropTypes.string
        }),
        title: PropTypes.string,
        children: PropTypes.arrayOf(PropTypes.shape({
          to: PropTypes.string,
          label: PropTypes.string
        })),
        noHelp: PropTypes.bool
      })
    })
  }

  crumb(child) {
    if (child.to) {
      return <a href={child.to} onClick={evt => { evt.preventDefault(); Navigation.go(child.to) }}>{ child.label }</a>
    } else {
      return <span className='title'>{ child.label }</span>
    }
  }

  append(crumbs, sep, child) {
    crumbs.push(<span key={sep}>&nbsp;/&nbsp;</span>)
    crumbs.push(<React.Fragment key={sep + '-child'}>{ this.crumb(child) }</React.Fragment>)
  }

  userLink() {
    const { current_user, breadcrumbs } = this.props
    const { params } = breadcrumbs.options

    if (!breadcrumbs.set) {
      return <span>Loading...</span>
    } else if (!(current_user || params)) {
      return <span className='title'></span>
    } else if (!current_user) {
      return <span className='title'>{ params.username }</span>
    } else {
      const { username } = params
      const pather = username === current_user.username ? Paths.profile : Paths.public_user
      const path = pather({ username })
      return <a href={path} onClick={evt => { evt.preventDefault(); Navigation.go(path) }}>{ username }</a>
    }
  }

  renderLinks() {
    const { breadcrumbs } = this.props
    let breadcrumbContent = [
      <React.Fragment key='user'>{ this.userLink() }</React.Fragment>
    ]

    if (breadcrumbs.set){
      const { options } = breadcrumbs

      if (options.children) {
        options.children.forEach((child, idx) => {
          // log('set breadcrumb child', child)
          this.append(breadcrumbContent, `sep-${idx}`, child)
        })
      }

      const { title } = options
      if (title) {
        // log('set breadcrumb title', title)
        this.append(breadcrumbContent, 'sep-title', { label: title })
      }
    }

    return breadcrumbContent
  }

  renderMobileLinks() {
    const { breadcrumbs } = this.props
    const { options } = breadcrumbs
    const { title } = options
    let breadcrumbContent = [ ]

    if (breadcrumbs.set){
      if (options.children && options.children[0]) {
        breadcrumbContent.push(<React.Fragment key='0-child'>{ this.crumb(options.children[0]) }</React.Fragment>)
        options.children.slice(1).forEach((child, idx) => {
          // log('set mobile breadcrumb child', child)
          this.append(breadcrumbContent, `sep-${idx}`, child)
        })
        if (title) {
          // log('set breadcrumb title', title)
          this.append(breadcrumbContent, 'sep-title', { label: title })
        }
      } else if (title) {
        // lonely title
        breadcrumbContent.push(<React.Fragment key='0-child'>{ this.crumb({ label: title }) }</React.Fragment>)
      }

    }

    return breadcrumbContent
  }

  renderHelp() {
    return this.props.breadcrumbs.options.noHelp
      ? null
      : <a className="btn rounded gray" target="_blank" href="https://learn.adafruit.com/welcome-to-adafruit-io">
          <i className="fas fa-circle-question"/> Help
        </a>
  }

  render() {
    if (!this.props.breadcrumbs.set) { return null }

    const
      links = this.renderLinks(),
      mobile = this.renderMobileLinks(),
      help = this.renderHelp()

    return (
      <div className="breadcrumbs">
        <div className="container hidden-xs">
          <div className="row">
            <div className="col-sm-9 content">
              { links }
            </div>
            <div className="col-sm-3 help">
              { help }
            </div>
          </div>
        </div>
        <div className="container hidden-sm visible-xs mobile">
          <div className="row">
            <div className="col-xs-12">
              <div className="content">
                  { mobile }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    current_user: state.session.user,
    breadcrumbs: state.breadcrumbs
  }
}

export default connect(mapStateToProps)(Breadcrumbs)
